module.exports = __webpack_public_path__ + "media/images/admin/icons/target-e999a3005d91c827aa26f3f1393686ba.svg";